<div mat-dialog-title>{{dialogTitle}}
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button>
</div>
<mat-dialog-content>
  <div class="block">
      <span class="bold">You are being redirected to a third-party website that is owned and operated by an independent information provider.</span> Use of this third-party site is subject to the terms and conditions of the Web Site User Agreement you agreed to upon use of Schwab Advisor Center web site.
  </div>
  <div class="block">
     <a (click)="openAgreements()" id="syntax-agreements-disclosures-link">Agreements</a>
  </div>
  <irb-expando-link text="Disclosures">
    <div class="block" style="font-size: 8pt;">
        Charles Schwab & Co., Inc. (Schwab) and Syntax, Inc. are separate, unaffiliated companies. Schwab and Syntax, Inc. are not responsible for each other's opinions, policies, and services. Any information, content, and data provided by Syntax is intended for investment professional use only and is not a substitute for appropriate model or other investment due diligence. It may not be distributed to your clients or other members of the public, nor used in written form as sales literature for public use. References to Schwab or iRebal are solely for integration purposes and do not imply any partnership, endorsement, recommendation, or approval by Schwab of the Syntax platform.
    </div>
    <div style="font-size: 8pt;">
        Schwab may receive compensation from third-party service providers for the integration and use of their services or platform.
    </div>
  </irb-expando-link>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="syntax-disclaimer-number" >(1026-7FVB)</div>
  <button (click)="close()" class="btn-medium-secondary syntax-dialog-cancel">Cancel</button>
  <button (click)="continue()" class="btn-medium-primary syntax-dialog-continue">Continue</button>
</mat-dialog-actions>

